import * as React from 'react';
import { Option, TOption } from '../../../utils/Option';
import { LoadingIndicator, Select as SelectStandard } from '@emorg-prd/standard-react';
import { Field } from './Field';
import { IValidation } from '../../../utils/Validation';
import './Select.css'

interface SelectProps extends Omit<React.ComponentProps<typeof SelectStandard>, 'children' | 'value' | 'onChange'> {
	fullWidth?: boolean;
	isLoading?: boolean;
	onChange: any;
	disabled?: boolean;
	options: TOption[];//Option[] | string[];
	className?: string;
	children?: React.ReactNode;
	validation?: IValidation;
	value: string | number;
}

const Select: React.FC<SelectProps> = (props) => {

	// const normalizedValue = props.value != null ? String(props.value) : '';
	const abstractTextInput = new (class extends Field<SelectProps> {
		constructor() {
			super({
				onChange: props.onChange,
				value: props.value,
				validation: props.validation,
				options: props.options
			});
		}
		})();

	const normalizedOptions = React.useMemo(
		() => props.options.map(op => new Option(op)),
		[props.options]
	);

	return (
		<>
			{!props.isLoading ?
				<SelectStandard
					{...props}
					state={props.disabled ? 'em-is-disabled' : (!abstractTextInput.isValid() ? 'em-has-error' : 'em-is-readonly')}
					value={props.value != null ? String(props.value) : ''}
					note={abstractTextInput.nonValidMessage() || props.note}
					optionalClass={`em-c-field ${props.fullWidth && 'full-width'}`}
					onChange={(value: string) => props.onChange({ target: { value } })}
				>
					{/* <optgroup> */}
						<option value='' hidden />
						{normalizedOptions.map((op: Option) => (
							<option className='em-c-field-option' key={op.value} value={String(op.value)}>
								{op.text}
							</option>
						))}
					{/* </optgroup> */}
				</SelectStandard>
				:
				<SelectStandard
					{...props}
					state={props.disabled ? 'em-is-disabled' : (!abstractTextInput.isValid() ? 'em-has-error' : 'em-is-readonly')}
					value={'Loading...'}
					note={abstractTextInput.nonValidMessage() || props.note}
					onChange={(value: string) => props.onChange({ target: { value } })}
				>
					<option value='' hidden />
					<option className='em-c-field-option' key='Loading options ...' value='Loading...'>
						Loading...
						<LoadingIndicator optionalClass="em-u-margin em-c-icon--medium" />
					</option>
				</SelectStandard>
			}
		</>
	);
}

export { Select };